class DashboardTotalMarginController  {
    constructor(createAutoQuery, $session, $scope) {
        let $ctrl = this;
        $ctrl.salesquery = createAutoQuery({
            url: 'QueryOrderTotals.json',
            criteria: {
                dateRange: $ctrl.date,
                startDate: $ctrl.start,
                endDate: $ctrl.end,
                vendorId: $ctrl.vendor
            },
            autoLoad: true,
            onLoaded: args => {$ctrl.refreshTotals();}
        });

        $ctrl.cogquery = createAutoQuery({
            url: 'QueryCOGTotals.json', 
            criteria: {
                dateRange: $ctrl.date,
                vendorId: $ctrl.vendor
    },
            autoLoad: true,
            onLoaded: args => {$ctrl.refreshTotals();}
        });

        $ctrl.shipquery = createAutoQuery({
            url: 'QueryFreightTotals.json', 
            criteria: {
                dateRange: $ctrl.date,
                vendorId: $ctrl.vendor
            },
            autoLoad: true,
            onLoaded: args => {$ctrl.refreshTotals();}
        });

        $ctrl.taxquery = createAutoQuery({
            url: 'QuerySalesTaxTotals.json', 
            criteria: {
                dateRange: $ctrl.date
            },
            autoLoad: true,
            onLoaded: args => {$ctrl.refreshTotals();}
        });

        $ctrl.$session = $session;
        $scope.$watch("$ctrl.date", function() {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.start", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.end", function () {
            $ctrl.reload();
        });
        $scope.$watch("$ctrl.vendor", function () {
            $ctrl.reload();
        });

    }
    refreshTotals() {
        let $ctrl = this;
        $ctrl.income = 0;
        $ctrl.profit = 0;
        $ctrl.margin = 0;
        $ctrl.income = $ctrl.salesquery.results[0].total;
        $ctrl.profit = $ctrl.salesquery.results[0].total - $ctrl.cogquery.results[0].total - $ctrl.shipquery.results[0].total - $ctrl.taxquery.results[0].total;
        $ctrl.margin = Math.round($ctrl.profit / $ctrl.income *  100);
    }
    reload() {
        let $ctrl = this;
        $ctrl.salesquery.criteria.dateRange = $ctrl.date;
        $ctrl.salesquery.criteria.startDate = $ctrl.start;
        $ctrl.salesquery.criteria.endDate = $ctrl.end;
        $ctrl.salesquery.criteria.vendorId = $ctrl.vendor;
        $ctrl.salesquery.load(true);

        $ctrl.cogquery.criteria.dateRange = $ctrl.date;
        $ctrl.cogquery.criteria.startDate = $ctrl.start;
        $ctrl.cogquery.criteria.endDate = $ctrl.end;
        $ctrl.cogquery.criteria.vendorId = $ctrl.vendor;
        $ctrl.cogquery.load(true);

        $ctrl.shipquery.criteria.dateRange = $ctrl.date;
        $ctrl.shipquery.criteria.startDate = $ctrl.start;
        $ctrl.shipquery.criteria.endDate = $ctrl.end;
        $ctrl.shipquery.criteria.vendorId = $ctrl.vendor;
        $ctrl.shipquery.load(true);

        $ctrl.taxquery.criteria.dateRange = $ctrl.date;
        $ctrl.taxquery.criteria.startDate = $ctrl.start;
        $ctrl.taxquery.criteria.endDate = $ctrl.end;
        $ctrl.taxquery.criteria.vendorId = $ctrl.vendor;
        $ctrl.taxquery.load(true);
    }
}

class DashboardTotalMargin{
    constructor(){
        this.bindings= {
            date: '@',
            start: '@',
            end: '@',
            vendor: '@'
        };
        this.controller = DashboardTotalMarginController;
    }

    templateUrl($element, $attrs) {
        return $attrs.templateUrl || 'dashboard-total-margin.html'
    }
}

angular.module('emun.shopping.admin').component('dashboardTotalMargin', new DashboardTotalMargin());

export default DashboardTotalMargin